import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import TimelineTimelineMobileArrows from './TImelineTimelineMobileArrows';
import TimelineTimelineYearSingle from './TimelineTimelineYearsSingle';
import { getElements, getElementYearSize, getHighlightMobileCenter, calcDecadeFromYear, getYearsFlat, getYearPrevOrNext, setHighlightClassesOnInit, getYearsCount, } from './Timeline._helpers';
import { COLOURS, DESKTOP_ELEMS, MOBILE_ELEMS, MOBILE_SCROLL } from './Timeline._constants';
import { P3 } from '../Typography';
import TimelineTimelineMobileDraggable from './TimelineTimelineMobileDraggable';
const Container = styled.div `
  margin: 0;
  display: flex;
  height: 76px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.primaryWhite};
`;
const ContainerListItem = styled.li `
  width: ${(props) => `${props.yearWidth}px`};
  padding-top: 12px;
  text-align: center;
  // cursor: pointer;

  // highlight siblings
  &.mobileYear {
    &.hl-left1,
    &.hl-right1 {
      span {
        font-size: 14px;
      }
    }

    &.hl-left2,
    &.hl-right2 {
      span {
        font-size: 10px;
      }
    }
  }
`;
const ContainerHighlightYear = styled.div `
  // @see also ContainerHighlightYearArrow in TimelineContent

  position: absolute;
  left: ${(props) => `${props.offSetLeft}px`};
  width: ${(props) => `${props.yearWidth}px`};
  height: 57px;
  padding-top: 12px;
  background-color: ${COLOURS.RED_10};
  text-align: center;
`;
const HighlightYearText = styled(P3).attrs(() => ({
    tag: 'span',
})) `
  font-size: 20px !important;
  font-weight: bold;
`;
const ContainerHighlightDecade = styled(ContainerHighlightYear) `
  margin-top: 48px;
  width: 45px;
  height: 24px;
  padding-top: 0;
  background-color: ${COLOURS.GREY_20};

  &:after {
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    top: -5px;
    margin: -7px 0 0 -5px;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid ${COLOURS.GREY_20};
    border-left: 6px solid transparent;
  }
`;
const HighlightDecadeText = styled(HighlightYearText) `
  font-size: 12px !important;
  font-weight: normal;
  
`;
const StyledTimelineTimelineMobileArrows = styled(TimelineTimelineMobileArrows) `
  flex: 0 0 28px;
`;
const TimelineTimelineMobile = ({ contentWidth, years, setYear, setId, setLang, handleClickArrow, clickYear, }) => {
    // @todo  useReducer if applicable
    let init = 0;
    // @todo  params & logic had already been set prior to using 's' for en/fr (refactor)
    // this is only to satisfy TS
    const isEn = setLang.indexOf('en') > -1;
    const suffix = isEn || true ? DESKTOP_ELEMS.DECADES.EN : '';
    const contParentID = MOBILE_ELEMS.CONT_PARENT.replace('#', '');
    const containerID = MOBILE_ELEMS.CONTAINER.replace('#', '');
    const yearsClass = MOBILE_ELEMS.YEARS.replace('.', '');
    const [tlScrollEl, setTlScrollEl] = useState(document.createElement('DIV'));
    const [yearWidth, setYearWidth] = useState(0);
    const [yearsFlat, setYearsFlat] = useState([]);
    const [highlightOffsetYear, setHighlightOffsetYear] = useState(0);
    const [highlightOffsetDecade, setHighlightOffsetDecade] = useState(0);
    useEffect(() => {
        // determine container width and apply year size based on this
        // as the parent container width can vary in mobile
        const tlScroll = getElements(MOBILE_ELEMS.CONTAINER, true);
        setTlScrollEl(tlScroll);
        setYearWidth(getElementYearSize(tlScrollEl));
    });
    useEffect(() => {
        // initialize, force run once on yearWidth
        if (!init) {
            setYearsFlat(getYearsFlat(years));
            setHighlightClassesOnInit();
            ++init;
        }
        // red year box, grey decade box
        const parent = getElements(MOBILE_ELEMS.CONT_PARENT, true);
        const offsetYear = getHighlightMobileCenter(parent, yearWidth);
        setHighlightOffsetYear(offsetYear);
        const offsetDecade = getHighlightMobileCenter(parent, 38);
        setHighlightOffsetDecade(offsetDecade - 4);
    }, [yearWidth]);
    const handleClickArrowLocal = (evt, direction) => {
        if (evt) {
            evt.preventDefault();
            evt.stopPropagation();
        }
        const yearGet = getYearPrevOrNext(yearsFlat, { year: setYear, id: setId }, direction === MOBILE_SCROLL.DIR_PREV ? -1 : 1);
        if (yearGet && yearGet.id !== setId) {
            handleClickArrow(yearGet.year, yearGet.id);
        }
    };
    return (React.createElement(Container, { id: contParentID },
        React.createElement(StyledTimelineTimelineMobileArrows, { arrow: MOBILE_SCROLL.DIR_PREV, className: MOBILE_ELEMS.ARROW_LEFT.replace('.', ''), handleClickArrow: handleClickArrowLocal }),
        React.createElement(TimelineTimelineMobileDraggable, { containerID: containerID, contentWidth: contentWidth, noYears: getYearsCount(years), yearWidth: yearWidth, years: getYearsFlat(years), className: yearsClass, handleUseClick: handleClickArrow, clickYear: clickYear }, years.map((yearSet) => {
            return yearSet.items.map((item, idx) => {
                return (React.createElement(ContainerListItem, { className: yearsClass, key: `CL${idx}`, yearWidth: yearWidth },
                    React.createElement(TimelineTimelineYearSingle, { handleClick: handleClickArrow, key: `s${item.toString()}`, id: item.id, year: item.year, yearWidth: yearWidth, isMobile: true })));
            });
        })),
        React.createElement(StyledTimelineTimelineMobileArrows, { arrow: MOBILE_SCROLL.DIR_NEXT, className: MOBILE_ELEMS.ARROW_RIGHT.replace('.', ''), handleClickArrow: handleClickArrowLocal }),
        React.createElement(ContainerHighlightYear, { yearWidth: yearWidth, offSetLeft: highlightOffsetYear, className: 'highlightYearYear' },
            React.createElement(HighlightYearText, { asWhite: true, field: { value: setYear } })),
        React.createElement(ContainerHighlightDecade, { yearWidth: yearWidth, offSetLeft: highlightOffsetDecade, className: 'highlightYearDecade' },
            React.createElement(HighlightDecadeText, { asWhite: true, field: { value: calcDecadeFromYear(setYear) + suffix } }))));
};
export default TimelineTimelineMobile;
//  @see setHighlightClassMod
// className={(item.year === setYear && item.id === setId) ? MOBILE_ELEMS.HIGHLIGHT.replace('.', '') : ''}
